/** Column names the engine keeps for itself (`__wb_row`, error columns). */
export const RESERVED_PREFIX = "__wb_";
export function isReserved(name: string): boolean {
  return name.toLowerCase().startsWith(RESERVED_PREFIX);
}
